import autobind from 'autobind-decorator';
import { FormProps, reduxForm } from 'redux-form';
import history from 'login-utils/history';
import PrimaryButton from 'login-components/Common/Buttons/PrimaryButton';
import AppTitleUpdater from 'login-components/Common/AppTitleUpdater';
import InputMap from 'login-components/Common/Inputs/InputMap';
import FormDialogFooter from 'login-components/Common/Form/FormDialog/FormDialogFooter';
import * as React from 'react';
import * as formUtils from 'login-utils/formUtils';
import { ssoCheck } from 'login-apis/lenderSSOAPI';
import { StatesRich } from 'login-constants/states';
import * as queryString from 'query-string';
import { setHref } from 'login-utils/globalWrappers';
import '../LoginForm/login-form.scss';
import OldFormBody from '../FormComponents/OldFormBody';
import { SSO_REDIRECT_URL } from '../LoginForm/loginFormUtils';

const LOGIN_PASSWORD_PATH = StatesRich.LENDER_LOGIN_PASSWORD_ONLY.path;
const inputs: FormInput[] = [
  {
    ...InputMap.EmailInput,
    name: 'username',
    identifier: 'username',
  },
];

interface LoginFormEmailOnlyState {
  errorMsg?: string;
}

interface FormData {
  username: string;
}

type ILoginFormEmailOnlyProps = FormProps<any, any, any>;

const FORM_ERROR_ID = 'LoginFormEmailOnly-formError';

@autobind
export class LoginFormEmailOnly extends React.Component<ILoginFormEmailOnlyProps, LoginFormEmailOnlyState> {
  constructor(props: ILoginFormEmailOnlyProps) {
    super(props);
    this.state = {
      errorMsg: undefined,
    };
  }

  // redirect to sso page if account is sso enabled, otherwise, show them password page.
  async submitLogin(formData: FormData) {
    const { username } = formData;
    try {
      const response = await ssoCheck(username);
      if (response.data.isSSO) {
        return setHref(SSO_REDIRECT_URL);
      }
      // redirect to login-password
      const query = queryString.stringify({
        username,
        from: 'loginEmail',
      });
      history.push(`/${LOGIN_PASSWORD_PATH}?${query}`);
    } catch (e) {
      // if sso check is failed. show an network error
      this.setState({
        errorMsg: 'There was an error. Please try again.',
      });
    }
  }

  render() {
    const actionText = 'Sign In';
    const { handleSubmit, submitting } = this.props;
    const { errorMsg } = this.state;
    return (
      <AppTitleUpdater text="Sign in to your account">
        <form className="LoginForm" id="it-LoginFormEmailOnly" noValidate onSubmit={handleSubmit!(this.submitLogin)}>
          <OldFormBody inputs={inputs} errorId={FORM_ERROR_ID} errorMsg={errorMsg} showForgotPassword={false} />
          <FormDialogFooter>
            <PrimaryButton buttonId="it-LoginSubmit" disabled={submitting} text={actionText} />
          </FormDialogFooter>
        </form>
      </AppTitleUpdater>
    );
  }
}

const ConnectedLoginFormEmailOnly = reduxForm({
  form: 'loginEmailOnly',
  validate: values => formUtils.validate(inputs, values),
  onSubmitFail: /* istanbul ignore next: (UI-5482) */ syncErrors =>
    formUtils.focusOnSubmitFail(syncErrors, FORM_ERROR_ID),
})(LoginFormEmailOnly);

export default ConnectedLoginFormEmailOnly;
